<template>
  <div class="SelectSearchPlanos" v-loading="loadingPage">
    <el-select
      clearable
      :disabled="disabled"
      v-model="modelData"
      style="width: 100%;"
      filterable
      remote
      :remote-method="serch"
      @change="change"
      :loading="loading">
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id">
        <span style="float: left">{{ item.name }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import {isNull} from "lodash";
import {getPlan} from "@/app/domains/Records/services";

export default {
  name: "SelectSearchPlanos",
  props: {
    model: {
      type: [String, Number],
      default: ''
    },
    isEdit: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    queryString: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      loadingPage: false,
      loading: false,
      options: [],
      modelData: ''
    }
  },
  watch: {
    'model': async function (query) {
      if (query !== this.modelData && query !== '' && !isNull(query)) {
        this.options = []
        this.loadingPage = true
        await this.serch(query, true)
      }
      if (isNull(query)) {
        this.modelData = ''
      }
    }
  },
  methods: {
    change (val) {
      this.$emit('handleValue', val)
      this.$emit('handleObjValue', this.options.find(x => {return x.id === val}))
    },
    async serch (query, edit = false) {
      this.loading = true
      try {
        if (edit) {
          let response = await getPlan('/'+query+this.queryString)
          this.options = [response.data]
          this.modelData = query
          this.loadingPage = false
        } else {
          
          let response = await getPlan('?name='+query+this.queryString)
          this.options = response.data.data
        }
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.message,
          type: 'error'
        })
      } finally {
        this.loading = false
        this.loadingPage = false
      }
    }
  },
  mounted() {
    if (!this.isEdit) {
      // this.serch('')
    } else {
      this.loadingPage = true
      this.modelData = this.model
      this.serch(this.modelData, true)
    }
  }
}
</script>

<style scoped>

</style>
